module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre_25",
    attrs: {
      "id": "filepos76212"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("9 "), _c('img', {
    staticClass: "calibre11",
    attrs: {
      "alt": "image",
      "src": "images/00004.jpg"
    }
  }), _vm._v(" Free-will - I")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Our sole freedom is the faculty of understanding, for there is only one mind, and nothing else is. (The T’ang Masters have been quoted to this effect, especially Hsi Yun.)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("It follows that our only liberty of “action” lies in the exercise of this faculty, and the resulting change in our apparent selves.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("If this should appear difficult to comprehend we might do well to envisage mind as an ultimate subtlety or essence traversing all dimensions, manifesting in all, and constituting thereby a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("liaison")]), _vm._v(" between the densest force-field of the material world and Absolute Reality, of which it is the purest manifestation perceptible to us.")])]), _vm._v(" "), _c('h3', {
    staticClass: "calibre_26",
    attrs: {
      "id": "filepos77296"
    }
  }, [_c('span', {
    staticClass: "calibre12"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("Free-will II")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("How can a figment of the imagination have any effect on anything that is not itself a figment of the imagination? Therefore any effect resulting from an act of “will” subject to the ego-concept can only be as imaginary as itself.")])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_33"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2202720","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_019.vue
// module id = 117
// module chunks = 0